export const ASAP = 'asap';
export const SCHEDULE = 'schedule';
export const ASAP_AND_SCHEDULE = 'ASAP / Schedule';
